import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

import { makeGetCurrentTeam } from '../selectors/teams';
import { makeGetTeamMessageNotifications } from '../selectors/notifications';

import { useCanUser } from 'shared-hooks/permission';

import NotificationsBubble from 'components/NotificationsBubble';

import IconExpand from '../icons/icon-expand';

const ChatToggle = ({ widgetOpen, chatDisabled, notificationsCount, guestChatDisabled, t, dispatch }) => {
    const haveFullChat = useCanUser('fullChat');

    const handleShowClick = () => {
        if (widgetOpen) {
            dispatch({ type: 'TEAMCHAT_WIDGET_CLOSE_REQUESTED' });
        } else {
            dispatch({ type: 'TEAMCHAT_WIDGET_OPEN_REQUESTED' });
        }
    }

    if (chatDisabled) {
        return null;
    }

    if (guestChatDisabled && !haveFullChat) {
        return null;
    }

    return (
        <div className="chat-toggle-panel">
            <button className="btn chat-toggle-btn" onClick={handleShowClick}>
                <span>
                    <i className="status-indicator active" />

                    { t('chat:Team Chat') }

                    <NotificationsBubble count={notificationsCount} />
                </span>

                <IconExpand />
            </button>
        </div>
    );
}

const makeMapStateToProps = () => {
    const getCurrentTeam = makeGetCurrentTeam();
    const getTeamMessageNotifications = makeGetTeamMessageNotifications();

    return ({ teams, notifications, teamChat }) => {
        const team = getCurrentTeam(teams);
        return {
            chatDisabled: team?.chat_disabled,
            guestChatDisabled: team?.client_chat_disabled,
            notificationsCount: getTeamMessageNotifications(notifications.items).length,
            widgetOpen: teamChat.widgetOpen
        };
    };
}

export default connect(makeMapStateToProps)(withTranslation('chat')(ChatToggle));
